import ApplyCreditOriginal from './ApplyCreditOriginal';

import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { withRouter } from 'react-router-dom';

import {
  errorSel,
  successSel,
  invoicesActions
} from 'src/store/modules/invoices';
import { IInvoiceCreditPayment } from 'src/services/invoice/InvoiceService';
import {
  creditCardActions,
  savedCreditCardsSel,
  selectedCardSel,
  creditCardErrorSel,
  creditCardSuccessSel,
  creditCardIsPendingSel
} from 'src/store/modules/creditcard';
import CreditCardModel from 'src/model/creditCard.model';
import { userDataSel, userActions } from 'src/store/modules/user';

const mapStateToProps = (state: IInitialState) => ({
  errorPayment: errorSel(state),
  successPayment: successSel(state),
  savedCreditCards: savedCreditCardsSel(state),
  selectedCreditCard: selectedCardSel(state),
  creditCardError: creditCardErrorSel(state),
  creditCardSuccess: creditCardSuccessSel(state),
  creditCardIsPending: creditCardIsPendingSel(state),
  userData: userDataSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  payInvoicesByCredit: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => {
    dispatch(invoicesActions.payInvoicesByCredit(invoicePayments, signature));
  },
  clearAlert: () => {
    dispatch(invoicesActions.setError(''));
    dispatch(invoicesActions.setSuccess());
    dispatch(creditCardActions.setError());
    dispatch(creditCardActions.setSuccess());
  },
  getUserDetails: () => {
    dispatch(userActions.getUserDetails());
  }
});

// export const pureDesktopComponent = ApplyCreditMadePayment;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(ApplyCreditOriginal)));
